import React, { useState, useContext } from "react";
import { AuthContext } from "../context/authContext.js";
import { useNavigate } from "react-router-dom"
import "../styles/login.css"

export default function LoginScreen(){
    const {login} = useContext(AuthContext)
    const navigate = useNavigate()

    const [name, setName] = useState("")
    const [password, setPassword] = useState("")

    const handleLogin = async (name_user, password_user) => {
        await login(name_user, password_user)
        navigate("/")
    }
    
    return(
        <div className="login-container">
            <div className="login-card">
                <img src="https://valsoft.es/wp-content/uploads/2022/06/logo_azul_fondo_blanco_PUNTOS-tr.png" width="180"  alt="Foto"></img>
                <p className="subtitle">Introduce tus credenciales para continuar</p>
            
                <div className="input-group">
                    <label>Nombre de usuario</label>
                    <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Ej: juan_perez"
                    />
                </div>

                <div className="input-group">
                    <label>Contraseña</label>
                    <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") handleLogin(name, password);
                     }}
                    />
                </div>

                <button className="login-button" onClick={() => handleLogin(name, password)}>
                    Continuar
                </button>
            </div>
        </div>
    )
}